// Which account a stored session belongs to, and whether it changed under a tab.

// The account a session token belongs to (its "sub" claim), or null.
export function tokenAccountId(token) {
  if (!token || typeof token !== "string") return null;
  const payload = token.split(".")[1];
  if (!payload) return null;
  try {
    const json = JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
    return json && json.sub != null ? String(json.sub) : null;
  } catch {
    return null;
  }
}

// Another tab signed in as a different account, or signed out: this tab must
// not carry on as the old account (it would show one account's app while the
// browser is signed in as another). A refreshed token for the same account
// needs nothing: the refresh cookie is shared, so this tab refreshes too.
export function storedSessionChangedAccount(currentToken, storedToken) {
  if (!currentToken || currentToken === storedToken) return false;
  if (!storedToken) return true;
  const current = tokenAccountId(currentToken);
  const stored = tokenAccountId(storedToken);
  return Boolean(current && stored && current !== stored);
}
